//
// universal-item-id-constants.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/*global angular: false */

(function() {
    'use strict';

    var curalate = angular.module('curalate');

    curalate.constant('UniversalImageActionsItemType', {
        bookmarklet: 'bookmarklet',
        conversations: 'conversations',
        desktop: 'desktop',
        facebook: 'facebook',
        fanreel: 'fanreel',
        instagram: 'instagram',
        like2buy: 'like2buy',
        mobile: 'mobile',
        pinterest: 'pinterest',
        reveal: 'reveal',
        savedImage: 'saved-image',
        schedulerInstagram: 'scheduler-instagram',
        schedulerPinterest: 'scheduler-pinterest',
        socialImage: 'social-mage',
        syndication: 'syndication',
        tumblr: 'tumblr',
        twitter: 'twitter',
        mediaItem: 'media-import'
    });

    curalate.constant('UniversalImageActionsNetworkTypes', ['pinterest', 'facebook', 'instagram', 'twitter', 'tumblr']);

    curalate.constant('RightsStatus', {
        Approved: 'approved',
        BrandOwned: 'brandowned',
        FailedToSend: 'failedtosend',
        None: 'none',
        NotSupported: 'notsupported',
        Pending: 'pending',
        Initiated: 'initiated',
        Queued: 'queued',
        Rejected: 'expired',
        Unsent: 'unsent',
        Cancelled: 'cancelled',
    });
})();
